import isEqual from 'lodash/isEqual';
import uniqWith from 'lodash/uniqWith';
import { ShoeSizeData } from './ShoeSizeData';
import { CrossCategorySizeData } from './CrossCategorySizeData';

class SizeData {
  static universal() {
    return 'U';
  }

  static all(department) {
    const crossCategory = SizeData.crossCategorySizes(department);
    return crossCategory.concat(SizeData.shoeSizes(null, department));
  }

  static crossCategorySizes(department) {
    return CrossCategorySizeData.all(department).map(el => new SizeData(el));
  }

  static shoeSizes(countryISO, departmentName) {
    return ShoeSizeData.filtered(countryISO, departmentName).map(el => new SizeData(el));
  }

  /* data is either ShoeSizeData or CrossCategorySizeData and should be considered private when interacting with this class */
  constructor(data = null) {
    this.data = data;
  }

  isShoeSize() {
    return this.data instanceof ShoeSizeData;
  }

  toDisplayString() {
    return this.data.toDisplayString();
  }

  toLongDisplayString() {
    return this.data.toLongDisplayString();
  }

  toStringRepresentation() {
    return this.data.toStringRepresentation();
  }

  static fromStringRepresentation(string, department) {
    const data =
      ShoeSizeData.fromStringRepresentation(string, department) ||
      CrossCategorySizeData.fromStringRepresentation(string, department);

    if (!data) {
      console.log(`Unknown size representation ${string} department ${department}`);
      return null;
    } else {
      return new SizeData(data);
    }
  }

  // strips out universal size
  static sizesArrayToString(sizes, department) {
    const filtered = sizes.filter(el => SizeData.universal() !== el);

    return filtered.map(el => SizeData.fromStringRepresentation(el, department)).filter(el => el);
  }

  // replaces universal size with all available for department
  static sizesArrayWithUniversalToString(sizes, shoeSizes, department) {
    if (sizes.length === 0) {
      return [];
    }

    let arr = [];

    sizes.forEach(el => {
      const isUniversal = SizeData.universal() === el;

      if (isUniversal && shoeSizes) {
        arr = arr.concat(SizeData.shoeSizes(null, department));
      } else if (isUniversal && !shoeSizes) {
        arr = arr.concat(SizeData.crossCategorySizes(department));
      } else {
        arr.push(SizeData.fromStringRepresentation(el, department));
      }
    });

    const nonDuplicateArray = uniqWith(arr, isEqual);

    return nonDuplicateArray.filter(el => el);
  }
}

export { SizeData };
